import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';

/**
 * Centralized Loader Component
 * Uses subtle animated loading bar from PageLoader
 * Optimized for performance with minimal re-renders
 */
const Loader = ({ minH = '60vh', width = { base: '60%', md: '300px' } }) => {
  return (
    <Flex
      justify="center"
      align="center"
      minH={minH}
      w="full"
    >
      {/* Subtle Loading Bar */}
      <Box
        width={width}
        height="5px"
        bg="rgba(0,0,0,0.1)"
        borderRadius="full"
        overflow="hidden"
      >
        <motion.div
          style={{
            width: "100%",
            height: "100%",
            background: "linear-gradient(90deg, transparent, rgba(0,0,0,0.6), transparent)",
            borderRadius: "full",
          }}
          animate={{
            x: ["-100%", "100%"],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </Box>
    </Flex>
  );
};

// Memoize to prevent unnecessary re-renders
export default React.memo(Loader);
